var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "resize",
          rawName: "v-resize",
          value: _vm.onResize,
          expression: "onResize"
        }
      ]
    },
    [
      _vm.isViewTable
        ? _vm._t("table", null, {
            items: _vm.items,
            loading: _vm.isLoading,
            contentHeightTable: _vm.contentHeightTable
          })
        : _c(
            "loader",
            { attrs: { "is-loading": _vm.isLoading } },
            [
              _c(
                "keep-alive",
                [
                  _c(
                    "transition",
                    { attrs: { name: "slide-fade" } },
                    [
                      _vm.items.length === 0
                        ? _c(
                            "v-row",
                            {
                              staticClass: "pa-3",
                              attrs: { justify: "center", align: "center" }
                            },
                            [
                              _c("p", { staticClass: "title warning--text" }, [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      _vm.generateMessage(
                                        `${_vm.i18nPath ||
                                          _vm.namespace}.noItems`
                                      )
                                    ) +
                                    "\n          "
                                )
                              ])
                            ]
                          )
                        : _vm._t("cards", null, { items: _vm.items })
                    ],
                    2
                  )
                ],
                1
              )
            ],
            1
          )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }